import Vue from 'vue';
import VueRouter from 'vue-router';
import Assets from '../pages/Assets';
import Monitor from '../pages/Monitor';
import Config from '../pages/Config';
import WorkingTime from '../pages/WorkingTime';
import AccountsWrapper from '../pages/Accounts';
import Accounts from '../views/Accounts';
import JSONPreview from '../components/Applications/JSONPreview.vue';
import RunnerPreview from '../components/Applications/RunnerPreview.vue';
import FlyoutMenu from '../components/FlyoutMenu';
import { TokenStorage } from "@/services/TokenStorage";
import logger from "@/plugins/logger";
import { postLoginRedirect } from "@/services/postLoginRedirect";
import MonitorDetailView from "../components/Monitoring/MonitorDetailView"
import CustomFields from '../views/CustomFields.vue';
import OperatorGroups from '../views/OperatorGroups.vue';
import Operators from '../views/Operators.vue';

const Locations = () => import('../views/Locations');
const Devices = () => import('../views/Devices');
const Groups = () => import('../views/Groups');
const Register = () => import('../views/Register');
const Applications = () => import('../views/Applications');
const WorkingTimeVue = () => import('../views/WorkingTime');
const Runners = () => import('../views/Runners');
const Invite = () => import('../views/Invite');
const Update = () => import('../views/Update');
const UpdateForgotPassword = () => import('../views/UpdateForgotPassword');
const Login = () => import('../views/Login');
const Success = () => import('../views/Success');
const ForgotPassword = () => import('../views/ForgotPassword');
const NewPassword = () => import('../views/NewPassword');
const Performance = () => import('../views/Performance');
const Activity = () => import('../views/Activity');
const Logs = () => import('../views/Logs');
const Events = () => import('../views/Events');
Vue.use(VueRouter);

const routes = [
  {
    path: '/account-registration',
    name: 'Register',
    component: Register
  },
  {
    path: '/space-join',
    name: 'Invite',
    component: Invite
  },
  {
    path: '/account-password-update',
    name: 'UpdatePassword',
    component: Update
  },
  {
    path: '/account-password-reset',
    name: 'UpdateForgotPassword',
    component: UpdateForgotPassword
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/update-account',
    name: 'Success',
    component: Success
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/change-password',
    name: 'NewPassword',
    component: NewPassword
  },
  {
    path: '/',
    redirect: { name: 'devices' },

    component: AccountsWrapper,
    children: [
      {
        path: 'administrators',
        name: 'Administrators',
        component: Accounts, // This component displays the list of administrators
        children: [
          {
            path: ':action', // Standalone route for adding a new admin
            name: 'accounts_action',
            component: FlyoutMenu,
          },
          {
            path: ':uuid', // Route for the detail view of a specific admin
            name: 'viewAdministrator',
            component: FlyoutMenu,
            props: true,
            children: [
              {
                path: 'edit', // Nested route for editing the selected admin
                name: 'editAdministrator',
                component: FlyoutMenu,
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: 'operators',
        name: 'operators',
        component: Operators,
        children: [
          {
            path: 'add/:progress?',
            name: 'addOperator',
            component: FlyoutMenu,
            props: true  // umjesto custom props funkcije
          },
          {
            path: ':uuid/:action?',
            name: 'viewOperator',
            component: FlyoutMenu,
            props: true,
            children: [
              {
                path: 'edit',
                action: 'edit',
                name: 'editOperator',
                component: FlyoutMenu,
                props: true,
              },
              {
                path: 'reset',
                action: 'reset',
                name: 'resetOperatorCredentials',
                component: FlyoutMenu
              }
            ],
          },
        ],
      },
      {
        path: 'operator-groups',
        name: 'operator-groups',
        component: OperatorGroups,
        children: [
          {
            path: 'add/:progress?', // Standalone route for adding a new operator group
            name: 'addOperatorGroup',
            component: FlyoutMenu,
          },
          {
            path: ':uuid', // Route for the detail view of a specific group
            name: 'viewOperatorGroup',
            component: FlyoutMenu,
            props: true,
            children: [
              {
                path: 'edit', // Nested route for editing the selected group
                action: 'edit',
                name: 'editOperatorGroup',
                component: FlyoutMenu,
                props: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/',
    redirect: 'devices',
    name: 'Assets',
    component: Assets,
    children: [
      {
        path: '/locations',
        name: 'locations',
        component: Locations,
        children: [
          {
            path: ':action',
            name: 'location_action',
            component: FlyoutMenu,
          },
          {
            path: ':location_type/:action/:uuid/:tab',
            name: 'location',
            component: FlyoutMenu,
          },
          {
            path: ':action',
            name: 'device_action',
            component: FlyoutMenu,
            props: true
          },
          {
            path: ':device_type/:action/:space_uuid/:uuid/:tab',
            name: 'device_location',
            component: FlyoutMenu,
            props: true,
          },
          {
            path: 'global',
            name: 'working_time_action',
            component: FlyoutMenu,
            props: true,

          }
        ],
      }, {
        path: '/devices',
        name: 'devices',
        component: Devices,
        props: true,
        children: [
          {
            path: ':action',
            name: 'devices_action',
            component: FlyoutMenu,
            props: true
          },
          {
            path: ':device_type/:action/:space_uuid/:uuid/:tab',
            name: 'device',
            component: FlyoutMenu,
            props: true,
          },
        ],
      },
      {
        path: "/groups",
        name: "groups",
        component: Groups,
        children: [
          {
            path: ':action',
            name: 'group_action',
            component: FlyoutMenu,
          },
          {
            path: ':group_type/:action/:space_uuid/:uuid/:tab',
            name: 'group',
            component: FlyoutMenu,
            props: true,
          },
        ]
      }
    ],
  },
  {
    path: '/',
    redirect: 'activity',
    name: 'Monitor',
    component: Monitor,
    children: [

      {
        path: '/activity',
        name: 'activity',
        component: Activity,
        children: [
          {
            path: ':action',
            name: 'activity_action',
            component: FlyoutMenu,
            props: true
          },
          {
            path: ':device_type/:action/:space_uuid/:uuid/:tab',
            name: 'activity_device',
            component: FlyoutMenu,
            props: true,
          },

        ],
      },
      {
        path: '/performance',
        name: 'performance',
        component: Performance,
        children: [
          {
            path: ':action',
            name: 'performance_action',
            component: FlyoutMenu,
            props: true
          },
          {
            path: ':monitoring_type/:action/:space_uuid/:uuid/:tab',
            name: 'performance_device',
            component: MonitorDetailView,
            props: true,
          },

        ],
      },
      {
        path: '/events',
        name: 'events',
        component: Events,
      },
      {
        path: '/logs',
        name: 'logs',
        component: Logs,
      }
    ]

  },
  {
    path: '/',
    redirect: 'applications',
    name: 'Config',
    component: Config,
    children: [
      {
        path: '/applications',
        name: 'Applications',
        component: Applications,
        children: [
          {
            path: ':appId',
            name: 'ApplicationDetails',
            component: JSONPreview, // Assuming JSONPreview is set up to function as a routed component
            props: true
          }
        ]
      },
      {
        path: '/runners',
        name: 'Runners',
        component: Runners,
        children: [
          {
            path: ':runnerId',
            name: 'RunnerDetails',
            component: RunnerPreview, // Assuming JSONPreview is set up to function as a routed component
            props: true
          }
        ]
      },
    ]

  },
  {
    path: '/',
    redirect: { name: 'working_time' }, // Default route
    name: 'WorkingTime',
    component: WorkingTime,
    children: [
      {
        path: 'working_time',
        name: 'working_time',
        component: WorkingTimeVue,
        props: true,
      },
      {
        path: 'custom_fields',
        name: 'custom_fields',
        redirect: { name: 'custom_fields_locations' },
        component: CustomFields,
        props: true,
        children: [
          {
            path: 'devices',
            name: 'custom_fields_devices',
            component: CustomFields,
            props: true,
          },
          {
            path: 'locations',
            name: 'custom_fields_locations',
            component: CustomFields,
            props: true,
          },
          {
            path: 'operators',
            name: 'custom_fields_operators', 
            component: CustomFields,
            props: true,
          }
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/",
    "/account-registration",
    "/account-password-update",
    "/account-password-reset",
    "/space-join",
    "/login",
    "/forgot-password",
    "/change-password",
    "/update-account",
  ];
  const authRequired = !publicPages.includes(to.path);
  const isAuthenticated = TokenStorage.isAuthenticated();

  if (authRequired && !isAuthenticated) {
    logger.error("Unauthorized", "", "IAM");
    // Remember where the user was trying to go so we can return them there
    // after they sign in (deep links to devices, locations, operators, etc.).
    postLoginRedirect.capture(to.fullPath);
    return next("/login");
  }

  // If already authenticated, skip the login page
  if (to.path === '/login' && isAuthenticated) {
    return next('/');
  }

  // Ensure users are redirected correctly after login
  if (to.path === '/' && isAuthenticated) {
    return next('/devices'); // Redirect authenticated users to devices
  }

  next();
});

export default router;